import { useState } from "react";
import { CoreFilterButton } from "../../core";
import i18nPackage from "../../i18n/i18n";
import styles from "./profileSection.module.css";

const ALL_PROFILE_TYPES = ["institute", "course", "user"] as const;
export type ProfileType = (typeof ALL_PROFILE_TYPES)[number];

type ProfileFilterButtonProps = {
	filter: ProfileType[];
	setFilter: (newFilter: ProfileType[]) => void;
};

export function ProfileFilterButton({ filter, setFilter }: ProfileFilterButtonProps) {
	const [profileFilter, setProfileFilter] = useState<ProfileType[]>(filter); // Checkbox state

	return (
		<CoreFilterButton
			filterCount={filter.length}
			onClear={() => setProfileFilter([])}
			onApply={() => setFilter(profileFilter)}
			filterSections={[
				{
					alignment: "top",
					sectionTitle: i18nPackage.t("editQuizPage.profileSectionTSX.filter.profileTitle"),
					checkboxes: ALL_PROFILE_TYPES.map((profile) => ({
						checked: profileFilter.includes(profile),
						onChange: (checked) => {
							const newProfileFilter = profileFilter.filter((p) => p !== profile);
							setProfileFilter(checked ? newProfileFilter.concat([profile]) : newProfileFilter);
						},
						children: i18nPackage.t(`editQuizPage.profileSectionTSX.profileType.${profile}`),
					})),
				},
			]}
			className={styles["profile-filter-button"]}
		/>
	);
}
